/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as LoginUserRouteImport } from './routes/login-user'
import { Route as LoginUaepassRouteImport } from './routes/login-uaepass'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as SignUpSuccessRouteImport } from './routes/sign-up/success'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as AppAiChatRouteImport } from './routes/app/ai-chat'
import { Route as App360AnalysisRouteImport } from './routes/app/360-analysis'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppDataImportIndexRouteImport } from './routes/app/data-import/index'
import { Route as AppSettingsNotificationsRouteImport } from './routes/app/settings/notifications'
import { Route as AppSettingsConnectCrmRouteImport } from './routes/app/settings/connect-crm'
import { Route as AppSettingsCompanyRouteImport } from './routes/app/settings/company'
import { Route as AppDataImportAddRouteImport } from './routes/app/data-import/add'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginUserRoute = LoginUserRouteImport.update({
  id: '/login-user',
  path: '/login-user',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginUaepassRoute = LoginUaepassRouteImport.update({
  id: '/login-uaepass',
  path: '/login-uaepass',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const SignUpSuccessRoute = SignUpSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => SignUpRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppAiChatRoute = AppAiChatRouteImport.update({
  id: '/ai-chat',
  path: '/ai-chat',
  getParentRoute: () => AppRoute,
} as any)
const App360AnalysisRoute = App360AnalysisRouteImport.update({
  id: '/360-analysis',
  path: '/360-analysis',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppDataImportIndexRoute = AppDataImportIndexRouteImport.update({
  id: '/data-import/',
  path: '/data-import/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsConnectCrmRoute = AppSettingsConnectCrmRouteImport.update({
  id: '/connect-crm',
  path: '/connect-crm',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsCompanyRoute = AppSettingsCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppDataImportAddRoute = AppDataImportAddRouteImport.update({
  id: '/data-import/add',
  path: '/data-import/add',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/login-uaepass': typeof LoginUaepassRoute
  '/login-user': typeof LoginUserRoute
  '/sign-up': typeof SignUpRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/app/360-analysis': typeof App360AnalysisRoute
  '/app/ai-chat': typeof AppAiChatRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/sign-up/success': typeof SignUpSuccessRoute
  '/app/': typeof AppIndexRoute
  '/app/data-import/add': typeof AppDataImportAddRoute
  '/app/settings/company': typeof AppSettingsCompanyRoute
  '/app/settings/connect-crm': typeof AppSettingsConnectCrmRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/app/data-import/': typeof AppDataImportIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/login-uaepass': typeof LoginUaepassRoute
  '/login-user': typeof LoginUserRoute
  '/sign-up': typeof SignUpRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/app/360-analysis': typeof App360AnalysisRoute
  '/app/ai-chat': typeof AppAiChatRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/sign-up/success': typeof SignUpSuccessRoute
  '/app': typeof AppIndexRoute
  '/app/data-import/add': typeof AppDataImportAddRoute
  '/app/settings/company': typeof AppSettingsCompanyRoute
  '/app/settings/connect-crm': typeof AppSettingsConnectCrmRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/app/data-import': typeof AppDataImportIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/login-uaepass': typeof LoginUaepassRoute
  '/login-user': typeof LoginUserRoute
  '/sign-up': typeof SignUpRouteWithChildren
  '/verify-email': typeof VerifyEmailRoute
  '/app/360-analysis': typeof App360AnalysisRoute
  '/app/ai-chat': typeof AppAiChatRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/sign-up/success': typeof SignUpSuccessRoute
  '/app/': typeof AppIndexRoute
  '/app/data-import/add': typeof AppDataImportAddRoute
  '/app/settings/company': typeof AppSettingsCompanyRoute
  '/app/settings/connect-crm': typeof AppSettingsConnectCrmRoute
  '/app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/app/data-import/': typeof AppDataImportIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/login-uaepass'
    | '/login-user'
    | '/sign-up'
    | '/verify-email'
    | '/app/360-analysis'
    | '/app/ai-chat'
    | '/app/onboarding'
    | '/app/settings'
    | '/sign-up/success'
    | '/app/'
    | '/app/data-import/add'
    | '/app/settings/company'
    | '/app/settings/connect-crm'
    | '/app/settings/notifications'
    | '/app/data-import/'
    | '/app/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/login-uaepass'
    | '/login-user'
    | '/sign-up'
    | '/verify-email'
    | '/app/360-analysis'
    | '/app/ai-chat'
    | '/app/onboarding'
    | '/sign-up/success'
    | '/app'
    | '/app/data-import/add'
    | '/app/settings/company'
    | '/app/settings/connect-crm'
    | '/app/settings/notifications'
    | '/app/data-import'
    | '/app/settings'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/login-uaepass'
    | '/login-user'
    | '/sign-up'
    | '/verify-email'
    | '/app/360-analysis'
    | '/app/ai-chat'
    | '/app/onboarding'
    | '/app/settings'
    | '/sign-up/success'
    | '/app/'
    | '/app/data-import/add'
    | '/app/settings/company'
    | '/app/settings/connect-crm'
    | '/app/settings/notifications'
    | '/app/data-import/'
    | '/app/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  LoginUaepassRoute: typeof LoginUaepassRoute
  LoginUserRoute: typeof LoginUserRoute
  SignUpRoute: typeof SignUpRouteWithChildren
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-user': {
      id: '/login-user'
      path: '/login-user'
      fullPath: '/login-user'
      preLoaderRoute: typeof LoginUserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-uaepass': {
      id: '/login-uaepass'
      path: '/login-uaepass'
      fullPath: '/login-uaepass'
      preLoaderRoute: typeof LoginUaepassRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/sign-up/success': {
      id: '/sign-up/success'
      path: '/success'
      fullPath: '/sign-up/success'
      preLoaderRoute: typeof SignUpSuccessRouteImport
      parentRoute: typeof SignUpRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/ai-chat': {
      id: '/app/ai-chat'
      path: '/ai-chat'
      fullPath: '/app/ai-chat'
      preLoaderRoute: typeof AppAiChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/360-analysis': {
      id: '/app/360-analysis'
      path: '/360-analysis'
      fullPath: '/app/360-analysis'
      preLoaderRoute: typeof App360AnalysisRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/data-import/': {
      id: '/app/data-import/'
      path: '/data-import'
      fullPath: '/app/data-import/'
      preLoaderRoute: typeof AppDataImportIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/notifications': {
      id: '/app/settings/notifications'
      path: '/notifications'
      fullPath: '/app/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/connect-crm': {
      id: '/app/settings/connect-crm'
      path: '/connect-crm'
      fullPath: '/app/settings/connect-crm'
      preLoaderRoute: typeof AppSettingsConnectCrmRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/company': {
      id: '/app/settings/company'
      path: '/company'
      fullPath: '/app/settings/company'
      preLoaderRoute: typeof AppSettingsCompanyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/data-import/add': {
      id: '/app/data-import/add'
      path: '/data-import/add'
      fullPath: '/app/data-import/add'
      preLoaderRoute: typeof AppDataImportAddRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsCompanyRoute: typeof AppSettingsCompanyRoute
  AppSettingsConnectCrmRoute: typeof AppSettingsConnectCrmRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsCompanyRoute: AppSettingsCompanyRoute,
  AppSettingsConnectCrmRoute: AppSettingsConnectCrmRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  App360AnalysisRoute: typeof App360AnalysisRoute
  AppAiChatRoute: typeof AppAiChatRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppDataImportAddRoute: typeof AppDataImportAddRoute
  AppDataImportIndexRoute: typeof AppDataImportIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  App360AnalysisRoute: App360AnalysisRoute,
  AppAiChatRoute: AppAiChatRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppDataImportAddRoute: AppDataImportAddRoute,
  AppDataImportIndexRoute: AppDataImportIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface SignUpRouteChildren {
  SignUpSuccessRoute: typeof SignUpSuccessRoute
}

const SignUpRouteChildren: SignUpRouteChildren = {
  SignUpSuccessRoute: SignUpSuccessRoute,
}

const SignUpRouteWithChildren =
  SignUpRoute._addFileChildren(SignUpRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  LoginUaepassRoute: LoginUaepassRoute,
  LoginUserRoute: LoginUserRoute,
  SignUpRoute: SignUpRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
